import { render, staticRenderFns } from "./EditReferenceModal.vue?vue&type=template&id=2195a299"
import script from "./EditReferenceModal.vue?vue&type=script&lang=js"
export * from "./EditReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./EditReferenceModal.vue?vue&type=style&index=0&id=2195a299&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports